import Menu1 from "../../assets/menu-1.png";
import Menu2 from "../../assets/menu-2.png";
import Menu3 from "../../assets/menu-3.png";
import Menu4 from "../../assets/menu-4.png";
import Menu5 from "../../assets/menu-5.png";
import Menu6 from "../../assets/menu-6.png";

const MenuJsonData = {
  MenuData: [
    {
      img: Menu1,
      title: "Twins Coffee",
    },
    {
      img: Menu2,
      title: "Cappuccino",
    },
    {
      img: Menu3,
      title: "Mocha Coffee",
    },
    {
      img: Menu4,
      title: "Frappuccino",
    },
    {
      img: Menu5,
      title: "Black Coffee",
    },
    {
      img: Menu6,
      title: "Heart Coffee",
    },
  ],
};

export default MenuJsonData;
